import { GCS_PROTOCOL, GOOGLE_CLOUD_STORAGE_HOST } from 'constant'

import { ImageProxy } from './image-proxy'

export const resizePhoto = (
  imageProxyHost: string,
  photo: string,
  width: number,
  height: number,
): string => {
  const imageProxy = new ImageProxy(imageProxyHost)
  imageProxy.size({ width, height })
  return imageProxy.generateUrl(photo, true)
}

export const parsePhotoGcsProtocol = (url: string): string => {
  if (url.includes(GOOGLE_CLOUD_STORAGE_HOST)) {
    return url.replace(`${GOOGLE_CLOUD_STORAGE_HOST}`, GCS_PROTOCOL)
  }
  return url.replace('/', GCS_PROTOCOL)
}
